import cookies from 'js-cookie';
import { colatex2svg } from './tool';
import logConfig from './log_config';

const REMOTE_LOGIN_DIALOG_KEY = 'remoteLoginDialogShow';

// 异地登录配置
export const REMOTE_LOGIN_CONFIG = {
  // 最大异地登录次数限制
  MAX_COUNT: 3,
  // 超过限制时的提示文案
  BLOCKED_MESSAGE: '异地登录无法授课，请联系客服或管理员',
  // 获取警告提示文案（超过限制时）
  getWarningMessageOverLimit(): string {
    return `当前账号已异地登录超过${this.MAX_COUNT}次，无法授课，请联系客服或管理员。`;
  },
  // 获取警告提示文案（未超过限制时）
  getWarningMessage(count: number): string {
    return `当前账号已异地登录${count}次，超过${this.MAX_COUNT}次将限制授课。`;
  },
};

function getTodayKey(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, '0');
  const day = `${now.getDate()}`.padStart(2, '0');
  return `${year}${month}${day}`;
}

/*
 * @Date: 2020-03-12 18:13:33
 * @LastEditors: yuanjianlong
 * @LastEditTime: 2025-10-24 16:43:24
 * @FilePath: /st-teacher-2020/src/utils/index.ts
 */
export default {
  /**
   * 点击事件埋点统计对应值
   * @param pathName 页面path
   * @param routeName 路由name
   * @param btnId 按钮id
   */
  getAad(pathName: string, routeName: string, btnId: string): string {
    try {
      pathName = pathName || this.getPathName();
      const { aads } = logConfig[pathName][routeName];
      const aad = aads[btnId];
      return aad;
    } catch (error) {
      return '';
    }
  },
  /**
   * 获取页面pathname
   */
  getPathName(): string {
    const { pathname } = window.location;
    // return pathname.substr(1, pathname.indexOf('.') - 1) || 'index';
    const name = pathname.substring(pathname.lastIndexOf('/') + 1, pathname.lastIndexOf('.')) || 'index';
    return name === '/' ? 'index' : name;
  },
  /**
   * 页面埋点对应id值
   * @param {*} pathName
   * @param {*} routeName
   */
  getPad(pathName: string, routeName: string) {
    // debugger;
    // pathName = pathName.toLowerCase();
    routeName = routeName.toLowerCase();
    if (pathName === '/' || pathName === '') {
      pathName = 'index';
    }
    try {
      const { pad } = logConfig[pathName][routeName];
      return pad;
    } catch (error) {
      return '';
    }
  },
  /**
   * 动态添加js
   * @param name script name
   * @param url script url
   */
  appendScript(name: string, url: string) {
    let urlTemp = '';
    return new Promise((resolve) => {
      if (url === undefined) {
        urlTemp = `/assets/libs/${name}`;
      } else {
        urlTemp = url;
      }

      if (!document.getElementById(name)) {
        const script = document.createElement('script');
        script.id = name;

        if (urlTemp.indexOf('?') === -1) {
          script.src = `${urlTemp}?v=${(`${Math.random()}`).replace('0.', '')}`;
        } else {
          script.src = `${urlTemp}&v=${(`${Math.random()}`).replace('0.', '')}`;
        }
        document.body.appendChild(script);
        script.onload = resolve;
      } else {
        resolve();
      }
    });
  },
  /**
   * 手动发送点击埋点
   * @param pathName 页面pathname
   * @param routeName 页面路由name
   * @param btnId 按钮id
   * @param options 参数
   */
  sendAction(pathName: string, routeName: string, btnId: string, options = {}): void {
    const aad = this.getAad(pathName, routeName, btnId);
    const maidianDom: any = document.getElementById('maidian_page');
    const uid = maidianDom.getAttribute('data-uid');
    const pad = maidianDom.getAttribute('data-pad');

    const target = document.createElement('div');
    target.setAttribute('data-uid', uid);
    target.setAttribute('data-pad', pad);
    target.setAttribute('data-aad', aad);
    if (Object.keys(options).length) {
      target.setAttribute('data-pp1', JSON.stringify(options));
    }

    window.track_util.send_action(target, 'clk');
  },
  /**
   * 处理链接换行问题
   * @param val
   */
  trimAll(val: string): string {
    return val.replace(/\s/g, '');
  },
  /**
   * 截取指定长度的字符
   * str:原字符串
   * n: 个数
   * */
  sub(str: string, n: number): string {
    const r: RegExp = /[\u4E00-\u9FA5]/g;
    if (str.replace(r, 'mm').length <= n) {
      return str;
    }
    const m: number = Math.floor(n / 2);
    for (let i = m; i < str.length; i += 1) {
      if (str.substr(0, i).replace(r, 'mm').length >= n) {
        return `${str.substr(0, i)}...`;
      }
    }
    return str;
  },

  storeHandleKey(key: string | number): string {
    const userId = cookies.get('userId');
    return `bsk_user_${userId}_${key}`;
  },
  setStore(key: string, value: any) {
    if (Object.prototype.toString.call(value) === '[object Object]') {
      value = JSON.stringify(value);
    }
    if (Object.prototype.toString.call(value) === '[object Array]') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(this.storeHandleKey(key), value);
  },
  getStore(key: string): any {
    let item = key && localStorage.getItem(this.storeHandleKey(key));
    try {
      item = item && JSON.parse(item);
    } catch (error) {
      // return item;
    }
    return item;
  },
  getExploreName() {
    const { userAgent } = navigator;
    if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
      return 'Opera';
    }
    if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1) {
      return 'IE';
    }
    if (userAgent.indexOf('Edge') > -1) {
      return 'Edge';
    }
    if (userAgent.indexOf('Firefox') > -1) {
      return 'Firefox';
    }
    if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
      return 'Safari';
    }
    if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1) {
      return 'Chrome';
    }
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      return 'IE>=11';
    }

    return 'Unkonwn';
  },
  debounce(func: any, wait = 0) {
    let timeout: any = null;
    let args: any;
    const debounced = (...arg: any) => {
      args = arg;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      return new Promise((res, rej) => {
        timeout = setTimeout(async () => {
          try {
            const result = await func.apply(this, args);
            res(result);
          } catch (error) {
            rej(error);
          }
        }, wait);
      });
    };
    // 允许取消
    function cancel() {
      clearTimeout(timeout);
      timeout = null;
    }
    // 允许立即执行
    const flush = () => {
      cancel();
      return func.apply(this, args);
    };
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  },
  // 试题选项
  questionOption(value: string) {
    return String.fromCharCode(parseInt(value, 10) + 65);
  },
  colatex2svgHandle(val: string) {
    return colatex2svg(val);
  },
  hasRemoteLoginDialogShownToday(userId?: string): boolean {
    const todayKey = getTodayKey();
    const stored = localStorage.getItem(REMOTE_LOGIN_DIALOG_KEY);
    if (!stored) {
      return false;
    }
    const [storedUserId, storedDate] = stored.split('_');
    return storedUserId === (userId) && storedDate === todayKey;
  },
  markRemoteLoginDialogShownToday(userId?: string) {
    const todayKey = getTodayKey();
    const value = `${userId}_${todayKey}`;
    localStorage.setItem(REMOTE_LOGIN_DIALOG_KEY, value);
  },
  /**
   * 格式化时长
   * @param value 单位：秒
   * @param formatType
   * @returns
   */
  formatSeconds(value: string | number, formatType = 0) {
    if (!value) {
      return 0;
    }
    const typeDetail = [
      { second: 's', minute: 'm', hour: 'h' },
      { second: 's', minute: 'm', hour: 'h' },
      { second: '秒', minute: '分钟', hour: '小时' },
      { second: '', minute: ':', hour: ':' },
    ];
    // 类似x分0秒这种是否显示x分
    const formatStyle = formatType === 1;
    //  秒
    let second = Math.round(+value);
    //  分
    let minute = 0;
    //  小时
    let hour = 0;
    //  天
    if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
      minute = parseInt(String(second / 60), 10);
      //  获取秒数，秒数取佘，得到整数秒数
      second = parseInt(String(second % 60), 10);
      //  如果分钟大于60，将分钟转换成小时
      if (minute > 60 && formatType !== 1) {
      //  获取小时，获取分钟除以60，得到整数小时
        hour = parseInt(String(minute / 60), 10);
        //  获取小时后取佘的分，获取分钟除以60取佘的分
        minute = parseInt(String(minute % 60), 10);
      }
    }

    let result = `${parseInt(String(second), 10)}${typeDetail[formatType]?.second}`;
    if (minute > 0) {
      result = `${parseInt(String(minute), 10)}${typeDetail[formatType]?.minute}${second === 0 && formatStyle ? '' : result}`;
    }
    if (hour > 0) {
      result = `${parseInt(String(hour), 10)}${typeDetail[formatType]?.hour}${second === 0 && minute === 0 && formatStyle ? '' : result}`;
    }

    return result;
  },
};
